import { PayloadAction } from '@reduxjs/toolkit';
import {
  GasketsState,
  GasketPricePayload,
  Gasket,
  PriceData,
  StockData,
} from './types';
import { constructItemDescription } from '../../singleItem/slice/utils';
import { ItemDescriptionParams } from '../../items/slice/types';

export const reducers = {
  addGasket(
    state: GasketsState,
    action: PayloadAction<{
      gasket: Gasket;
      customDescriptionData: ItemDescriptionParams;
    }>,
  ) {
    const customItemDescription = constructItemDescription(
      action.payload.customDescriptionData,
    );
    const finalGasket = {
      ...action.payload.gasket,
      customItemDescription,
    };
    if (!state.data) {
      state.data = [finalGasket];
    } else {
      state.data.push(finalGasket);
    }
  },
  clearGaskets(state: GasketsState) {
    state.data = null;
  },
  addGaskets(state: GasketsState, action: PayloadAction<Gasket[]>) {
    if (!state.data) {
      state.data = action.payload;
    } else {
      state.data.push(...action.payload);
    }
  },
  fetchPriceByErp(
    state: GasketsState,
    action: PayloadAction<GasketPricePayload>,
  ) {
    state.data?.forEach(gasket => {
      if (gasket && gasket.erpPartNumber === action.payload.erpPartNumber) {
        gasket.price.isLoading = true;
        gasket.price.error = null;
      }
    });
  },
  fetchPriceByErpSuccess(
    state: GasketsState,
    action: PayloadAction<{ data: PriceData; erpPartNumber: string }>,
  ) {
    state.data?.forEach(standardGasket => {
      if (standardGasket.erpPartNumber === action.payload.erpPartNumber) {
        standardGasket.price.data = action.payload.data;
        standardGasket.price.isLoading = false;
        standardGasket.price.error = null;
      }
    });
  },
  fetchPriceByErpFail(
    state: GasketsState,
    action: PayloadAction<{ error: unknown; erpPartNumber: string }>,
  ) {
    state.data?.forEach(standardGasket => {
      if (standardGasket.erpPartNumber === action.payload.erpPartNumber) {
        standardGasket.price.data = null;
        standardGasket.price.isLoading = false;
        standardGasket.price.error = action.payload.error;
      }
    });
  },
  fetchStandardGasketPrice(state: GasketsState, action: PayloadAction<string>) {
    state.data?.forEach(gasket => {
      if (gasket && gasket.erpPartNumber === action.payload) {
        gasket.price.isLoading = true;
        gasket.price.error = null;
      }
    });
  },
  fetchStockStatusByErp(state: GasketsState, action: PayloadAction<string>) {
    state.data?.forEach(standardGasket => {
      if (standardGasket.erpPartNumber === action.payload) {
        standardGasket.stockStatus.isLoading = true;
        standardGasket.stockStatus.error = null;
        standardGasket.stockStatus.data = null;
      }
    });
  },
  fetchStockStatusByErpSuccess(
    state: GasketsState,
    action: PayloadAction<{ data: StockData; erpPartNumber: string }>,
  ) {
    state.data?.forEach(standardGasket => {
      if (standardGasket.erpPartNumber === action.payload.erpPartNumber) {
        standardGasket.stockStatus.isLoading = false;
        standardGasket.stockStatus.error = false;
        standardGasket.stockStatus.data = action.payload.data;
      }
    });
  },
  fetchStockStatusByErpFail(
    state: GasketsState,
    action: PayloadAction<{ erpPartNumber: string; error: unknown }>,
  ) {
    state.data?.forEach(standardGasket => {
      if (standardGasket.erpPartNumber === action.payload.erpPartNumber) {
        standardGasket.stockStatus.error = action.payload.error;
        standardGasket.stockStatus.isLoading = false;
        standardGasket.stockStatus.data = null;
      }
    });
  },
  setQuantityByErp(
    state: GasketsState,
    action: PayloadAction<{
      values: GasketPricePayload;
      quantity: number;
      isStandard: boolean;
    }>,
  ) {
    state.data?.forEach(gasket => {
      if (gasket.erpPartNumber === action.payload.values.erpPartNumber) {
        gasket.price.itemQuantity = action.payload.quantity;
      }
    });
  },
  addToCartStandardGasket(state: GasketsState, action: PayloadAction<string>) {
    state.data?.forEach(gasket => {
      if (gasket.erpPartNumber === action.payload) {
        gasket.addToCart.isLoading = true;
        gasket.addToCart.data = false;
        gasket.addToCart.error = null;
      }
    });
  },
  addToCartStandardGasketSuccess(
    state: GasketsState,
    action: PayloadAction<string>,
  ) {
    state.data?.forEach(gasket => {
      if (gasket.erpPartNumber === action.payload) {
        gasket.addToCart.isLoading = false;
        gasket.addToCart.data = true;
        gasket.addToCart.error = null;
      }
    });
  },
  setShowPriceResults(state: GasketsState, action: PayloadAction<boolean>) {
    state.showPriceResults = action.payload;
  },
  fetchStandardGaskets() {},
  fetchStandardGasketsSuccess(
    state: GasketsState,
    action: PayloadAction<Gasket[]>,
  ) {
    state.data?.push(...action.payload);
  },
};
